var React = require('react');
var Radium = require('radium');

var NavLink = require('./NavLink');

var logo = require('../static/ajato-logo.png');

var style ={
	nav: {
		position: 'fixed',
		top: 0,
		right: 0,
		left: 0,
		width: '100%',
		minHeight: 50,
		maxHeight: 50,
		zIndex: 1030,
		borderWidth: '0px 0px 1px',
		borderStyle: 'solid'
	},

	navAdmin: {
		backgroundColor: '#063950'
	},

	navClient: {
		backgroundColor: '#f8f8f8',
		borderColor: '#e7e7e7'
	},

	navItens: {
		display: 'flex',
		margin: '0px 15px',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: 50,
		color: '#a6a6a6'
	},

	navItensAdmin: {
		color: '#fff'
	},

	list: {
		display: 'flex'
	},

	itemList: {
		margin: '0px 10px'
	},

	itemListLink: {
		color: '#a6a6a6',
		margin: '0px 5px'
	},

	itemListLinkAdmin: {
		color: '#fff'
	},

	brand: {
		color: '#ffde00'
	}
};

var Header = Radium(React.createClass({

	isAdmin: function() {
		return this.props.typeHeader === "admin";
	},

	getHello: function() {
		var me = this;

		if (me.isAdmin())
			return ( <span>{"Olá, admin"}</span> );
		else 
			return ( <img src={logo} alt='ajato' /> )
	},

	getBrand: function() {
		var me = this;

		if (me.isAdmin())
			return ( <span>{"AJATO"}<span style={style.brand}>{"ADMIN"}</span> </span> );
		else 
			return ( <img src={logo} alt='ajato' /> )
	},

	getAuthedMenu: function() {
		var me = this, props = me.props;

		if (me.isAdmin()) {
			return (
				<ul>
					<a style={[style.itemListLink, style.itemListLinkAdmin]} 
						onClick={props.refresh} 
						className="icon-reload"/>
					<a style={[style.itemListLink, style.itemListLinkAdmin]} 
						onClick={props.signOut}>
						{"Sair"}
					</a>
				</ul>
			)
		}

		return (
			<ul>
				<NavLink style={style.itemListLink} to={{pathname: '/'}}>
					{"Home"}
				</NavLink>

				<NavLink style={style.itemListLink} to={{pathname: '/user/orders'}}>
					{"Meus pedidos"}
				</NavLink>

				<a style={style.itemListLink} 
					onClick={props.signOut}>
					{"Sair"}
				</a>
			</ul>
		)
	},

	getNotAuthedMenu: function() {
		var me = this;

		if (me.isAdmin())
			return null;
		
		return (
			<ul>
				<NavLink style={style.itemListLink} to={{pathname: '/'}}>
					{"Home"}
				</NavLink>

				<a style={style.itemListLink} id="custom-signup">
					{"Cadastre-se"}
				</a>

				<a style={style.itemListLink} id="custom-login">
					{"Login"}
				</a>
			</ul>
		)
	},

	render: function() {
		var me = this, props = me.props;

		return (
			<nav 
				style={ me.isAdmin() 
						? [style.nav, style.navAdmin] 
						: [style.nav, style.navClient]} 
				className="navHeader">

				<div style={me.isAdmin() ? [style.navItens, style.navItensAdmin] : style.navItens}>
					{props.authenticated
						? me.getHello()
						: me.getBrand()}

					{props.authenticated
						? me.getAuthedMenu()
						: me.getNotAuthedMenu()
					}
				</div>
			</nav>
		);
	}
}));

module.exports = Header;


// WEBPACK FOOTER //
// ./src/components/Header.jsx